<template>
  <grey-tabs v-model="tab" :tabs="computedTabs" has-border cols="auto">
    <v-tab-item>
      <admin-input-row :translation-path="rowTitle" v-bind="{ titleCols: 12 }" name="datasource" align="baseline">
        <template #datasource.input>
          <v-row no-gutters>
            <v-col v-bind="colsAttrs">
              <data-sources-settings-list
                :data-sources="computedDataSources"
                :is-fetched="isFetched"
                :has-add-button="hasAddButton"
                :disabled="disabled"
              ></data-sources-settings-list>
            </v-col>
          </v-row>
        </template>
      </admin-input-row>
    </v-tab-item>
    <v-tab-item>
      <draggable-lists-layers
        :scope="scope"
        :is-fetched="isFetched"
        :disabled="disabled"
        :schema_scope="schema_scope"
      ></draggable-lists-layers>
    </v-tab-item>
    <v-tab-item v-for="(tab, index) in additionalTabs" :key="index">
      <slot :name="tab.name"> </slot>
    </v-tab-item>
  </grey-tabs>
</template>

<script>
import { get, call } from 'vuex-pathify';

import GreyTabs from '@/components/GreyTabs';
import AdminInputRow from '@/components/AdminInputRow';
import DataSourcesSettingsList from '@/components/DataSourcesSettingsList';
import DraggableListsLayers from '@/components/DraggableListsLayers';

export default {
  name: 'AdminTabsLayers',
  components: {
    GreyTabs,
    AdminInputRow,
    DataSourcesSettingsList,
    DraggableListsLayers,
  },
  props: {
    scope: {
      type: String,
      required: true,
    },
    tabProp: {
      type: Number,
      default: 0,
    },
    schema_scope: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    additionalTabs: {
      type: Array,
      default: () => [],
    },
    colsAttrs: {
      type: Object,
      default: () => ({
        lg: 9,
        md: 12,
        xl: 8,
      }),
    },
  },
  data: vm => ({
    tab: vm.tabProp,
    tabs: [{ name: vm.$i18n.t('admin.datasourcesSettings') }, { name: vm.$i18n.t('navbar.layers') }],
    isFetched: false,
  }),
  computed: {
    dataSources: get('layers/metadata'),
    translatedTitle() {
      return `admin.datasourcesType${this.scope}`;
    },
    listTitleType() {
      return `admin.datasourcesList${this.scope}`;
    },
    rowTitle() {
      return `admin.datasourcesType${this.scope}`;
    },
    inputs() {
      return [
        {
          align: 'baseline',
          name: 'datasourcesList',
          translationPath: this.listTitleType,
        },
      ];
    },
    hasAddButton() {
      return this.scope === 'core';
    },
    computedDataSources() {
      return Object.values(this.dataSources).filter(value => value.scope === this.scope);
    },
    computedTabs() {
      return [...this.tabs, ...this.additionalTabs];
    },
  },
  methods: {
    getDatasourcesSettings: call('datasourceSettings/getDatasourcesSettings'),
    getLayers: call('layers/getLayers'),
    getDataSources: call('layers/getLayersMetadata'),
    getLayersSchemaByScope: call('layers/getLayersSchemaByScope'),
    async onInit() {
      await Promise.all([
        this.getDatasourcesSettings(),
        this.getLayers({ scope: this.scope }),
        this.getLayersSchemaByScope({ layer_scope: this.scope, schema_scope: this.schema_scope }),
        this.getDataSources({
          with_attributes_schema: true,
          scope: this.scope,
          with_layers: true,
          with_last_edit: true,
          with_owner: true,
        }),
      ]);
      this.isFetched = true;
    },
  },
  created() {
    this.onInit();
  },
};
</script>

<style lang="scss" scoped></style>
